"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var DefaultLayout_1;
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLayout = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const nest_interconnectors_1 = require("@rws-framework/nest-interconnectors");
const ServiceWorkerService_1 = __importStar(require("@rws-framework/client/src/services/ServiceWorkerService"));
const browser_router_1 = require("@rws-framework/browser-router");
const component_1 = require("../../components/site-menu/component");
const StorageService_1 = __importStar(require("../../services/StorageService"));
const SignalService_1 = __importStar(require("../../services/SignalService"));
const PopupService_1 = __importStar(require("../../services/PopupService"));
const WSService_audio_1 = __importStar(require("../../services/WSService.audio"));
const router_1 = require("./listeners/router");
const notify_1 = require("./listeners/notify");
const auth_1 = require("./listeners/auth");
const events_1 = require("@front/event/events");
const translations_1 = require("../../application/globals/translations");
const currencies_1 = require("../../../../common/translations/currencies");
browser_router_1.RouterComponent;
component_1.SiteMenu;
//@ts-ignore                
let rwsTemplate = T.html `${(0, fast_element_1.when)(x => x.landingPage, (0, fast_element_1.html) `<page-landing></page-landing>`, (0, fast_element_1.html) `
<div id="root" class="${x => x.isLogged ? '' : 'not-logged'}">
    <div class="${x => x.isLogged ? '' : 'h-100'}">
        <notifications-area :notifications="${x => x.notifications}"></notifications-area>

        ${(0, fast_element_1.when)(x => x.isLogged, (0, fast_element_1.html) `
        <div id="app-container"
            class="menu-default${x => [0].includes(x.menuState) ? ' main-hidden' : ''}${x => [0, 1].includes(x.menuState) ? ' sub-hidden' : ''}">
            <nav-bar></nav-bar>

            
            ${(0, fast_element_1.when)(x => x.showLimitWarning, (0, fast_element_1.html) `
            <div class="limit-warning-bar">
                <div class="limit-warning-content">
                    <i class="simple-icon-exclamation"></i>
                    <span class="limit-warning-message">${x => x.limitWarningMessage}</span>
                    <a @click="${(x, c) => x.goUpgrade(c.event)}" class="link" href="${x => x.limitWarningLink}">${x => x.limitWarningLink}</a>
                    <button class="limit-warning-close" @click="${(x) => x.closeLimitWarning()}">
                        <i class="simple-icon-close"></i>
                    </button>
                </div>
            </div>
            `)}

            <site-menu :currentUrl="${x => x.currentUrl}" :menuState="${x => x.menuState}"
                :passedFrontRoute="${x => x.frontRoute}"></site-menu>

            <main>
                <div class="container-fluid">
                    <div class="dashboard-wrapper">
                        <rws-router :currentHash="${x => x.currentHash}" :currentUrl="${x => x.currentUrl}" />
                    </div>
                </div>
            </main>
        </div>
        `, (0, fast_element_1.html) `
        ${(0, fast_element_1.when)(x => !x.forceRegister, (0, fast_element_1.html) `
        ${(0, fast_element_1.when)(x => x.resetPasswordMode, (0, fast_element_1.html) `<password-reset-page></password-reset-page>`, (0, fast_element_1.html) `<page-login
            :onLogin="${x => x.onLogin.bind(x)}"></page-login>`)}
        `)}

        ${(0, fast_element_1.when)(x => x.forceRegister, (0, fast_element_1.html) `
        <page-register :onRegister="${x => x.onRegister.bind(x)}"></page-register>
        `)}
        `)}
    </div>

    
    <knowledge-form-modal :isOpen="${x => x.showKnowledgeModal}" :closeModal="${x => x.closeKnowledgeModal.bind(x)}"
        :payload="${x => x.knowledgePayload}" @knowledge-created="${(x, c) => x.onKnowledgeCreated(c.event)}">
    </knowledge-form-modal>
</div>
`)}`;
require("./styles/layout.scss");
const styles = T.css `#root {
  display: block;
}
#root.not-logged {
  height: 100%;
}

main {
  margin-top: 70px;
  margin-bottom: 0px;
}

.limit-warning-bar {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  width: 100%;
  background-color: #ffc107;
  color: #212529;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.limit-warning-bar .limit-warning-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  max-width: 100%;
}
.limit-warning-bar .limit-warning-content .simple-icon-exclamation {
  margin-right: 12px;
  font-size: 16px;
  color: #856404;
}
.limit-warning-bar .limit-warning-content .limit-warning-message {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}
.limit-warning-bar .limit-warning-content a.link {
  text-decoration: underline;
  color: #e9e7e7;
  font-weight: 600;
  margin-left: 12px;
  margin-right: 12px;
  cursor: pointer;
  transition: color 0.2s ease;
}
.limit-warning-bar .limit-warning-content a.link:hover {
  color: #FFF;
  text-decoration: none;
}
.limit-warning-bar .limit-warning-content .limit-warning-close {
  background: none;
  border: none;
  color: #856404;
  cursor: pointer;
  padding: 4px 8px;
  margin-left: 12px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
.limit-warning-bar .limit-warning-content .limit-warning-close:hover {
  background-color: rgba(133, 100, 4, 0.1);
}
.limit-warning-bar .limit-warning-content .limit-warning-close .simple-icon-close {
  font-size: 14px;
}

#app-container:has(.limit-warning-bar) main {
  margin-top: 120px;
}`;
const shadowOptions = { "mode": "open" };
let DefaultLayout = DefaultLayout_1 = class DefaultLayout extends client_1.RWSViewComponent {
    constructor(storageService, popupService, signalService, apiService, wsService, wsAudioService, swService) {
        super();
        this.storageService = storageService;
        this.popupService = popupService;
        this.signalService = signalService;
        this.apiService = apiService;
        this.wsService = wsService;
        this.wsAudioService = wsAudioService;
        this.swService = swService;
        this.currentHash = window.location.hash;
        this.notifications = [];
        this.menuOpen = true;
        this.resetPasswordMode = false;
        this.isLogged = false;
        this.landingPage = false;
        this.forceRegister = false;
        this.currentUrl = window.location.pathname;
        this.showKnowledgeModal = false;
        this.knowledgePayload = {};
        this.showLimitWarning = false;
        this.redirectedToUpgrade = false;
        this.limitWarningMessage = '';
        this.limitWarningLink = '';
        this.menuState = 2; // 0 - closed, 1 - main menu open, 2 - sub menu open
        this.menuOpening = false;
        this.loaded = false;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.creditBalanceSignal = this.signalService.getSignal('creditBalance', { initialValue: 0 });
        router_1.listenRouter.bind(this)();
        notify_1.listenNotify.bind(this)();
        auth_1.listenAuth.bind(this)();
        this.setupLimitWarningListener();
        // Listen for credit balance refresh events
        this.on('credit:balance:updated', async () => {
            const userData = await this.apiService.back.get('user.logged');
            if (userData.success && userData.data.user) {
                DefaultLayout_1.setUser(userData.data.user);
            }
            this.refreshCreditBalance();
        });
        if (window.location.pathname === '/password-reset' || window.location.pathname.startsWith('/password-reset/confirm')) {
            this.resetPasswordMode = true;
        }
        const storedJWT = this.storageService.getToken();
        DefaultLayout_1.$instance = this;
        if (storedJWT) {
            const userData = await this.apiService.back.post('auth.check', { token: storedJWT });
            if (userData.success && userData.data.user) {
                this.onLogin(userData.data.user, userData.data.token);
                this.refreshCreditBalance();
            }
            else {
                this.storageService.clearUser();
                this.apiService.setToken(null);
            }
        }
        this.loaded = false;
        this.on(client_1.RWSEvents.domEvents.loadedLinkedStyles, () => {
            if (!this.loaded) {
                this.getBody().classList.add('loaded');
                this.getPreloader().addEventListener('transitionend', () => {
                    if (!this.loaded) {
                        this.togglePreloader();
                        this.loaded = true;
                    }
                });
            }
        });
        this.on(events_1.appEvents.setMenuState, (event) => {
            this.menuState = event.detail.state;
            if (this.menuState === 2) {
                this.menuOpening = false;
            }
        });
        this.on(events_1.appEvents.menuToggle, () => {
            if (!this.menuOpening) {
                this.menuState--;
            }
            else {
                if (this.menuState === 1 && !this.$('site-menu').submenu.length) {
                    // If we're at state 1 with no submenu, close the menu instead
                    this.menuState = 0;
                    this.menuOpening = true;
                    return;
                }
                this.menuState++;
            }
            if (this.menuState == 0) {
                this.menuOpening = true;
            }
            if (this.menuState == 2) {
                this.menuOpening = false;
            }
        });
        this.on(events_1.appEvents.openKnowledgeModal, (event) => {
            this.showKnowledgeModal = true;
            this.knowledgePayload = event.detail || {};
        });
        // Listen for popup events from RWS components
        this.on(events_1.appEvents.popupShow, (event) => {
            const { message, type, params } = event.detail;
            let translatedMessage = message.t();
            // Replace parameters in the translation if params are provided
            if (params && typeof params === 'object') {
                Object.keys(params).forEach(key => {
                    translatedMessage = translatedMessage.replace(`{${key}}`, params[key]);
                });
            }
            switch (type) {
                case 'error':
                    this.popupService.error(translatedMessage);
                    break;
                case 'info':
                    this.popupService.alert(translatedMessage);
                    break;
                case 'warning':
                case 'success':
                default:
                    this.popupService.alert(translatedMessage);
                    break;
            }
        });
        // Listen for DOM events from Lit components (like chat-component)
        document.addEventListener('appEvents.popupShow', (event) => {
            const { message, type, params } = event.detail;
            let translatedMessage = message.t();
            // Replace parameters in the translation if params are provided
            if (params && typeof params === 'object') {
                Object.keys(params).forEach(key => {
                    translatedMessage = translatedMessage.replace(`{${key}}`, params[key]);
                });
            }
            switch (type) {
                case 'error':
                    this.popupService.error(translatedMessage);
                    break;
                case 'info':
                    this.popupService.alert(translatedMessage);
                    break;
                case 'warning':
                case 'success':
                default:
                    this.popupService.alert(translatedMessage);
                    break;
            }
        });
        if (window.location.pathname === '/' && !DefaultLayout_1.USER) {
            this.landingPage = true;
        }
    }
    async onLogin(user, token) {
        var _a;
        this.apiService.setToken(token);
        this.storageService.setToken(token);
        this.wsService.setToken(token);
        this.wsService.init();
        this.wsAudioService.setToken(token);
        this.wsAudioService.init();
        this.swService.setToken(token);
        this.isLogged = true;
        DefaultLayout_1.setUser(user);
        this.getBody().classList.remove('background');
        this.getBody().classList.remove('no-footer');
        this.getBody().classList.add('right-menu');
        if ((0, translations_1.getLanguage)() !== 'en') {
            try {
                // Try to get currency rate from backend first
                const targetCurrency = (0, currencies_1.getCurrency)((0, translations_1.getLanguage)()).toUpperCase();
                // We'll set up the API service after client initialization, so use direct fetch for now
                const data = await this.apiService.back.get(`currency.getRate`, { routeParams: { from: 'USD', to: targetCurrency } });
                if (data.success && ((_a = data.data) === null || _a === void 0 ? void 0 : _a.rate)) {
                    localStorage.setItem('rws_currency_rate', String(data.data.rate));
                }
                else {
                    throw new Error('Backend currency rate failed');
                }
            }
            catch (error) {
                localStorage.removeItem('rws_currency_rate');
                console.error('Error fetching currency rate from both backend and NBP:', error);
            }
        }
        if (!window.location.pathname.startsWith('/payment/confirmed') && user.accountGrade.price === 0 && this.currentUrl === '/' && !this.redirectedToUpgrade) {
            this.currentUrl = '/account/upgrade';
            this.redirectedToUpgrade = true;
        }
        if (this.currentUrl === '/login') {
            this.currentUrl = '/ai/chat';
        }
    }
    clearAuth() {
        this.apiService.setToken(null);
        this.wsService.setToken(null);
        this.wsAudioService.setToken(null);
        this.swService.sendConfirmedMessage('clear_token', {}, { asset_type: 'auth' });
    }
    async onRegister(user, token) {
        this.storageService
            .setToken(token);
        this.apiService.setToken(token);
        this.isLogged = true;
        DefaultLayout_1.setUser(user);
        this.getBody().classList.remove('background');
        this.getBody().classList.remove('no-footer');
        this.getBody().classList.add('right-menu');
    }
    async refreshCreditBalance() {
        try {
            const response = await this.apiService.back.get('user.account.balance');
            if (response && response.success && response.data) {
                this.creditBalanceSignal.setValue(response.data.credits);
            }
        }
        catch (error) {
            console.error('Failed to refresh credit balance:', error);
        }
    }
    getBody() {
        return document.querySelector('body');
    }
    getPreloader() {
        return document.querySelector('#preloader');
    }
    togglePreloader() {
        const preloader = this.getPreloader();
        if (preloader.classList.contains('hidden')) {
            preloader.classList.remove('hidden');
        }
        else {
            preloader.classList.add('hidden');
        }
    }
    storage() {
        return this.storageService;
    }
    closeKnowledgeModal() {
        this.showKnowledgeModal = false;
    }
    onKnowledgeCreated(event) {
        // Emit the event for any listeners (like knowledge picker) using native DOM events
        const customEvent = new CustomEvent('knowledge-created', {
            detail: event.detail,
            bubbles: true
        });
        document.dispatchEvent(customEvent);
        this.closeKnowledgeModal();
    }
    static get(querySelector = null) {
        const inst = DefaultLayout_1.$instance;
        if (querySelector === null) {
            return inst;
        }
        return inst.$(querySelector);
    }
    setupLimitWarningListener() {
        try {
            const limitSignal = this.signalService.getSignal('account-limit-reached');
            limitSignal.value$.subscribe(data => {
                if (data && data.message) {
                    this.showLimitWarningIfAllowed(data.message, data.upgradeLink || 'limits.upgrade.link'.t());
                }
            });
        }
        catch (error) {
            console.error('Error setting up limit warning listener:', error);
        }
    }
    showLimitWarningIfAllowed(message, upgradeLink = '') {
        const STORAGE_KEY = 'limit-warning-closed';
        const COOLDOWN_MINUTES = 15;
        try {
            const closedTimestamp = this.storageService.get(STORAGE_KEY);
            if (closedTimestamp) {
                const closedTime = parseInt(closedTimestamp);
                const now = Date.now();
                const timeDiff = now - closedTime;
                const cooldownMs = COOLDOWN_MINUTES * 60 * 1000;
                if (timeDiff < cooldownMs) {
                    // Still in cooldown period, don't show warning
                    return;
                }
            }
            // Show the warning bar
            this.limitWarningMessage = message;
            this.limitWarningLink = upgradeLink;
            this.showLimitWarning = true;
        }
        catch (error) {
            console.error('Error checking limit warning cooldown:', error);
        }
    }
    hideLimitWarning() {
        this.showLimitWarning = false;
        this.limitWarningMessage = '';
        this.limitWarningLink = '';
    }
    closeLimitWarning() {
        try {
            const STORAGE_KEY = 'limit-warning-closed';
            this.storageService.set(STORAGE_KEY, Date.now().toString());
            this.hideLimitWarning();
        }
        catch (error) {
            console.error('Error closing limit warning:', error);
        }
    }
    static setUser(user) {
        this.$instance.storageService
            .setUser(user);
        DefaultLayout_1.USER = user;
        window.rws_currentUser = user;
        this.$instance.$emit(events_1.appEvents.login, { success: true });
    }
    goUpgrade(e) {
        e.preventDefault();
        this.hideLimitWarning();
        component_1.SiteMenu.goto.bind(this)('/account/upgrade');
    }
    getCurrentUser() {
        return DefaultLayout_1.USER;
    }
    getCreditBalanceSignal() {
        return this.creditBalanceSignal;
    }
    static emit(event, detail) {
        if (this.$instance) {
            this.$instance.$emit(event, detail);
        }
    }
};
exports.DefaultLayout = DefaultLayout;
DefaultLayout.USER = null;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], DefaultLayout.prototype, "frontRoute", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], DefaultLayout.prototype, "currentPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], DefaultLayout.prototype, "currentHash", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], DefaultLayout.prototype, "notifications", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], DefaultLayout.prototype, "menuOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], DefaultLayout.prototype, "resetPasswordMode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], DefaultLayout.prototype, "isLogged", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], DefaultLayout.prototype, "landingPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], DefaultLayout.prototype, "forceRegister", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], DefaultLayout.prototype, "currentUrl", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], DefaultLayout.prototype, "showKnowledgeModal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_h = typeof Partial !== "undefined" && Partial) === "function" ? _h : Object)
], DefaultLayout.prototype, "knowledgePayload", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], DefaultLayout.prototype, "showLimitWarning", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], DefaultLayout.prototype, "redirectedToUpgrade", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], DefaultLayout.prototype, "limitWarningMessage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], DefaultLayout.prototype, "limitWarningLink", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], DefaultLayout.prototype, "menuState", void 0);
exports.DefaultLayout = DefaultLayout = DefaultLayout_1 = __decorate([
    (0, client_1.RWSView)('default-layout', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(StorageService_1.default)),
    __param(1, (0, client_1.RWSInject)(PopupService_1.default)),
    __param(2, (0, client_1.RWSInject)(SignalService_1.default)),
    __param(3, client_1.ApiService),
    __param(4, (0, client_1.RWSInject)(nest_interconnectors_1.WSService)),
    __param(5, (0, client_1.RWSInject)(WSService_audio_1.default)),
    __param(6, (0, client_1.RWSInject)(ServiceWorkerService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _a : Object, typeof (_b = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _b : Object, typeof (_c = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _c : Object, typeof (_d = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _d : Object, typeof (_e = typeof nest_interconnectors_1.WSServiceInstance !== "undefined" && nest_interconnectors_1.WSServiceInstance) === "function" ? _e : Object, typeof (_f = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _f : Object, typeof (_g = typeof ServiceWorkerService_1.ServiceWorkerServiceInstance !== "undefined" && ServiceWorkerService_1.ServiceWorkerServiceInstance) === "function" ? _g : Object])
], DefaultLayout);
DefaultLayout.defineComponent();
